import React from 'react';
import { twMerge } from 'utilities/src/twMerge';

import { ILabelTopProps } from './_props';

import useInputLabelTopTheme from './themes';
import Wrapper from './_Wrapper';

/**
 * LabelTop Component
 */

function LabelTop({
  id,
  label,
  labelPosition,
  theme,
  size = 'Medium',
  required = false,
  labelClassName,
  htmlFor,
}: ILabelTopProps) {
  const { labelTopThemeClasses, labelTopColorThemeClasses, labelTopOptionalThemeClasses, labelTopSizeClasses } =
    useInputLabelTopTheme({
      inputTheme: theme,
      inputSize: size,
    });

  if (!label || labelPosition !== 'Top') return null;

  return (
    <Wrapper
      id={`label-top-${id}`}
      className={twMerge(
        'label',
        labelTopThemeClasses,
        labelTopColorThemeClasses,
        labelTopSizeClasses,
        labelClassName,
      )}
      htmlFor={htmlFor}
    >
      {label}

      {!required && <span className={labelTopOptionalThemeClasses}> (Optional) </span>}
    </Wrapper>
  );
}

export default LabelTop;
